import React from "react";

export default function NoDataComp({ text, bgColor }) {
  return (
    <div
      style={{
        width: "100%",
        height: "200px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "20px",
        fontWeight: "700",
        backgroundColor: bgColor ? bgColor : "#ffffff"
      }}
    >
      {text ? text : "No Data Available"}
    </div>
  );
}
